import axios from "axios";
import { saveAs } from 'file-saver';

export default {
  namespaced: true,
  state: {
    id: null,
    name: '',
    code: '',
    accountName: '',
    tel: '',
    mail: '',
    prefectureCode: '',
    storeName: '',
    storeMail: '',
    address: '',
    zipCode: '',
    student1Cnt: '',
    student2Cnt: '',
    student3Cnt: '',
    teacher1Cnt: '',
    teacher2Cnt: '',
    teacher3Cnt: '',
    class1Cnt: '',
    class2Cnt: '',
    class3Cnt: '',
    cityId: '',
    material: '',
    gradeIds: [],
    subjectIds: [],
    subjectOptionIds: [],
    isTemporary: false,
    materialPasswords: [
      '',
      '',
      '',
      '',
      '',
    ],
    subjectGradeKeys: [],
    nichijoSubjectGradeKeys: [],
    shingakuSubjectGradeKeys: {},
    registeredUsers: [],
    registeredSchoolId: null,
    // おためし活動用ページ(/otameshi)から始まった登録フローか。戻る遷移先の判定に使用
    isOtameshiFlow: false,
    // 登録完了画面からログイン画面へ引き継ぐログイン情報(おためし用・案1)
    prefillLogin: null,
    prefillPassword: null,
  },

  getters: {
    title: state => {
      return state.id ? '編集' : '新規作成'
    },
    url: state => {
      return state.id
        ? `api/v1/admin/schools/${state.id}`
        : 'api/v1/admin/schools.xlsx'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    responseType: state => {
      return state.id ? 'json' : 'blob'
    },
    dataType: state => {
      return state.id ? 'json' : 'binary'
    },
    data: state => {
      return {
        name: state.name,
        code: state.code,
        account_name: state.accountName,
        tel: state.tel,
        mail: state.mail,
        prefecture_code: state.prefectureCode,
        store_name: state.storeName,
        store_mail: state.storeMail,
        address: state.address,
        zip_code: state.zipCode,
        student_1_cnt: state.student1Cnt ? parseInt(state.student1Cnt) : null,
        student_2_cnt: state.student2Cnt ? parseInt(state.student2Cnt) : null,
        student_3_cnt: state.student3Cnt ? parseInt(state.student3Cnt) : null,
        teacher_1_cnt: state.teacher1Cnt ? parseInt(state.teacher1Cnt) : null,
        teacher_2_cnt: state.teacher2Cnt ? parseInt(state.teacher2Cnt) : null,
        teacher_3_cnt: state.teacher3Cnt ? parseInt(state.teacher3Cnt) : null,
        class_1_cnt: state.class1Cnt ? parseInt(state.class1Cnt) : null,
        class_2_cnt: state.class2Cnt ? parseInt(state.class2Cnt) : null,
        class_3_cnt: state.class3Cnt ? parseInt(state.class3Cnt) : null,
      };
    },
  },

  mutations: {
    setId(state, payload) {
      state.id = payload.id;
    },
    setName(state, payload) {
      state.name = payload.name;
    },
    setCode(state, payload) {
      state.code = payload.code;
    },
    setAccountName(state, payload) {
      state.accountName = payload.accountName;
    },
    setTel(state, payload) {
      state.tel = payload.tel;
    },
    setMail(state, payload) {
      state.mail = payload.mail;
    },
    setPrefectureCode(state, payload) {
      state.prefectureCode = payload.prefectureCode;
    },
    setStoreName(state, payload) {
      state.storeName = payload.storeName;
    },
    setStoreMail(state, payload) {
      state.storeMail = payload.storeMail;
    },
    setAddress(state, payload) {
      state.address = payload.address;
    },
    setZipCode(state, payload) {
      state.zipCode = payload.zipCode;
    },
    setStudent1Cnt(state, payload) {
      state.student1Cnt = payload.student1Cnt;
    },
    setStudent2Cnt(state, payload) {
      state.student2Cnt = payload.student2Cnt;
    },
    setStudent3Cnt(state, payload) {
      state.student3Cnt = payload.student3Cnt;
    },
    setTeacher1Cnt(state, payload) {
      state.teacher1Cnt = payload.teacher1Cnt;
    },
    setTeacher2Cnt(state, payload) {
      state.teacher2Cnt = payload.teacher2Cnt;
    },
    setTeacher3Cnt(state, payload) {
      state.teacher3Cnt = payload.teacher3Cnt;
    },
    setClass1Cnt(state, payload) {
      state.class1Cnt = payload.class1Cnt;
    },
    setClass2Cnt(state, payload) {
      state.class2Cnt = payload.class2Cnt;
    },
    setClass3Cnt(state, payload) {
      state.class3Cnt = payload.class3Cnt;
    },
    setCityId(state, payload) {
      state.cityId = payload.cityId;
    },
    setGradeIds(state, payload) {
      state.gradeIds = payload.gradeIds;
    },
    setSubjectIds(state, payload) {
      state.subjectIds = payload.subjectIds;
    },
    setSubjectOptionIds(state, payload) {
      state.subjectOptionIds = payload.subjectOptionIds;
    },
    setMaterial(state, payload) {
      state.material = payload.material;
    },
    setTemporary(state, payload) {
      state.isTemporary = payload.isTemporary
    },
    setMaterialPasswords(state, payload) {
      state.materialPasswords = payload.materialPasswords;
    },
    setIsOtameshiFlow(state, payload) {
      state.isOtameshiFlow = payload.isOtameshiFlow;
    },
    setPrefillCredentials(state, payload) {
      state.prefillLogin = payload.login;
      state.prefillPassword = payload.password;
    },
    setSubjectGradeKeys(state, payload) {
      state.subjectGradeKeys = payload.subjectGradeKeys;
    },
    setNichijoSubjectGradeKeys(state, payload) {
      state.nichijoSubjectGradeKeys = payload.nichijoSubjectGradeKeys;
    },
    setShingakuSubjectGradeKeys(state, payload) {
      state.shingakuSubjectGradeKeys = payload.shingakuSubjectGradeKeys;
    },
    setRegisteredUsers(state, payload) {
      state.registeredUsers = payload.registeredUsers;
      state.registeredSchoolId = payload.schoolId || null;
    },
    clearRegisteredUsers(state) {
      state.registeredUsers = [];
      state.registeredSchoolId = null;
    },
    setSchool(state, payload) {
      state.id = payload.id;
      state.name = payload.name;
      state.code = payload.code;
      state.accountName = payload.account_name;
      state.tel = payload.tel;
      state.mail = payload.mail;
      state.prefectureCode = payload.prefecture_code;
      state.storeName = payload.store_name;
      state.storeMail = payload.store_mail;
      state.address = payload.address;
      state.zipCode = payload.zip_code;
      state.student1Cnt = payload.student_1_cnt ? payload.student_1_cnt.toString() : '';
      state.student2Cnt = payload.student_2_cnt ? payload.student_2_cnt.toString() : '';
      state.student3Cnt = payload.student_3_cnt ? payload.student_3_cnt.toString() : '';
      state.teacher1Cnt = payload.teacher_1_cnt ? payload.teacher_1_cnt.toString() : '';
      state.teacher2Cnt = payload.teacher_2_cnt ? payload.teacher_2_cnt.toString() : '';
      state.teacher3Cnt = payload.teacher_3_cnt ? payload.teacher_3_cnt.toString() : '';
      state.class1Cnt = payload.class_1_cnt ? payload.class_1_cnt.toString() : '';
      state.class2Cnt = payload.class_2_cnt ? payload.class_2_cnt.toString() : '';
      state.class3Cnt = payload.class_3_cnt ? payload.class_3_cnt.toString() : '';
      state.cityId = payload.city_id ? payload.city_id : '';
      state.material = payload.material ? payload.material : '';
      state.gradeIds = payload.grade_ids ? payload.grade_ids : [];
      state.subjectIds = payload.subject_ids ? payload.subject_ids : [];
      state.subjectOptionIds = payload.subject_option_ids ? payload.subject_option_ids : [];
    },
    initialize(state) {
      state.id = null;
      state.name = '';
      state.code = '';
      state.accountName = '';
      state.tel = '';
      state.mail = '';
      state.prefectureCode = '';
      state.storeName = '';
      state.storeMail = '';
      state.address = '';
      state.zipCode = '';
      state.student1Cnt = '';
      state.student2Cnt = '';
      state.student3Cnt = '';
      state.cityId = null;
      state.material = '';
      state.gradeIds = [];
      state.subjectIds = [];
      state.subjectOptionIds = [];
      state.isTemporary = false;
      state.materialPasswords = [
        '',
        '',
        '',
        '',
        '',
      ];
      state.subjectGradeKeys = [];
      state.nichijoSubjectGradeKeys = [];
      state.shingakuSubjectGradeKeys = {};
    },
  },

  actions: {
    async validate({ state }) {
      // 学校名が入力されているか
      if (!state.name) return {status: 'error', message: '学校名を入力してください'}
      // 学校名が20文字以内か
      if (state.name.length > 20) return {status: 'error', message: '学校名は20文字以内で入力してください'}

      // 学校コードが入力されているか
      if (!state.code) return {status: 'error', message: '学校コードを入力してください'}
      // 学校コードが10文字以内か
      if (state.code.length > 10) return {status: 'error', message: '学校コードは10文字以内で入力してください'}
      // 学校コードが半角英数か
      if (!state.code.match(/^[a-zA-Z0-9]+$/)) return {status: 'error', message: '学校コードはは半角英数字で入力してください'}

      // 都道府県が選択されているか
      if (!state.prefectureCode) return {status: 'error', message: '都道府県を選択してください'}

      if (state.tel && state.tel.length) {
        // 電話番号が11文字以内か
        if (state.tel.length > 11) return {status: 'error', message: '電話番号は11文字以内で入力してください'}
        // 電話番号が半角数字か
        if (!state.tel.match(/^[0-9]+$/)) return {status: 'error', message: '電話番号は半角数字で入力してください'}
      }

      if (state.mail && state.mail.length) {
        // メールアドレスの形式が正しいか
        if (!state.mail.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) return {status: 'error', message: 'メールアドレスの形式が正しくありません'}
      }

      if (!state.storeName) return {status: 'error', message: '販売店名を入力してください'}

      if (state.storeName.length > 20) return {status: 'error', message: '販売店名は20文字以内で入力してください'}

      if (state.storeMail && state.storeMail.length) {
        if (!state.storeMail.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) return {
          status: 'error',
          message: '販売店メールアドレスの形式が正しくありません'
        }
      }

      // 生徒数
      if (state.student1Cnt && state.student1Cnt.length) {
        // 生徒数が3文字以内か
        if (state.student1Cnt.length > 3) return {status: 'error', message: '生徒数は3文字以内で入力してください'}
        // 生徒数が半角数字か
        if (!state.student1Cnt.match(/^[0-9]+$/)) return {status: 'error', message: '生徒数は半角数字で入力してください'}
      }
      if (state.student2Cnt && state.student2Cnt.length) {
        // 生徒数が3文字以内か
        if (state.student2Cnt.length > 3) return {status: 'error', message: '生徒数は3文字以内で入力してください'}
        // 生徒数が半角数字か
        if (!state.student2Cnt.match(/^[0-9]+$/)) return {status: 'error', message: '生徒数は半角数字で入力してください'}
      }
      if (state.student3Cnt && state.student3Cnt.length) {
        // 生徒数が3文字以内か
        if (state.student3Cnt.length > 3) return {status: 'error', message: '生徒数は3文字以内で入力してください'}
        // 生徒数が半角数字か
        if (!state.student3Cnt.match(/^[0-9]+$/)) return {status: 'error', message: '生徒数は半角数字で入力してください'}
      }

      // 教師数
      if (state.teacher1Cnt && state.teacher1Cnt.length) {
        // 教師数が3文字以内か
        if (state.teacher1Cnt.length > 3) return {status: 'error', message: '教師数は3文字以内で入力してください'}
        // 教師数が半角数字か
        if (!state.teacher1Cnt.match(/^[0-9]+$/)) return {status: 'error', message: '教師数は半角数字で入力してください'}
      }
      if (state.teacher2Cnt && state.teacher2Cnt.length) {
        // 教師数が3文字以内か
        if (state.teacher2Cnt.length > 3) return {status: 'error', message: '教師数は3文字以内で入力してください'}
        // 教師数が半角数字か
        if (!state.teacher2Cnt.match(/^[0-9]+$/)) return {status: 'error', message: '教師数は半角数字で入力してください'}
      }
      if (state.teacher3Cnt && state.teacher3Cnt.length) {
        // 教師数が3文字以内か
        if (state.teacher3Cnt.length > 3) return {status: 'error', message: '教師数は3文字以内で入力してください'}
        // 教師数が半角数字か
        if (!state.teacher3Cnt.match(/^[0-9]+$/)) return {status: 'error', message: '教師数は半角数字で入力してください'}
      }

      // クラス数
      if (state.class1Cnt && state.class1Cnt.length) {
        // クラス数が3文字以内か
        if (state.class1Cnt.length > 3) return {status: 'error', message: 'クラス数は3文字以内で入力してください'}
        // クラス数が半角数字か
        if (!state.class1Cnt.match(/^[0-9]+$/)) return {status: 'error', message: 'クラス数は半角数字で入力してください'}
      }
      if (state.class2Cnt && state.class2Cnt.length) {
        // クラス数が3文字以内か
        if (state.class2Cnt.length > 3) return {status: 'error', message: 'クラス数は3文字以内で入力してください'}
        // クラス数が半角数字か
        if (!state.class2Cnt.match(/^[0-9]+$/)) return {status: 'error', message: 'クラス数は半角数字で入力してください'}
      }
      if (state.class3Cnt && state.class3Cnt.length) {
        // クラス数が3文字以内か
        if (state.class3Cnt.length > 3) return {status: 'error', message: 'クラス数は3文字以内で入力してください'}
        // クラス数が半角数字か
        if (!state.class3Cnt.match(/^[0-9]+$/)) return {status: 'error', message: 'クラス数は半角数字で入力してください'}
      }


      return {status: 'success', message: ''}
    },
    async temporaryValidation({ state }) {
      // 都道府県が選択されているか
      if (!state.prefectureCode) return {status: 'error', message: '都道府県を選択してください'}
      // 市区町村が選択されているか
      if (!state.cityId) return {status: 'error', message: '市区町村を選択してください'}
      // 学校が選択されているか
      if (!state.id) return {status: 'error', message: '学校を選択してください'}
      // 教科が選択されているか
      if (!state.subjectIds.length) return {status: 'error', message: '教科を選択してください'}
      // 学年が選択されているか（学年コードなしの教材のみの場合はスキップ）
      // おためしはsubjectGradeKeysを持たないため、常に学年の選択を必須とする
      const hasGradeCode = state.subjectGradeKeys.some(key => !!key.split('_')[1])
      if ((hasGradeCode || state.isOtameshiFlow) && !state.gradeIds.length) return {status: 'error', message: '学年を選択してください'}
      // 担当者名が入力されているか（おためし活動用アカウントは先生名の入力を必須としない）
      if (!state.isOtameshiFlow && !state.accountName) return {status: 'error', message: '担当者名を入力してください'}

      return {status: 'success', message: ''}
    },
    async submit({ getters }) {
      const school = getters.data
      const url = getters.url
      const method = getters.method
      const title = getters.title
      const responseType = getters.responseType
      const dataType = getters.dataType

      const res = await axios({
        url: url,
        method: method,
        data: {
          school: school
        },
        responseType: responseType,
        dataType: dataType,
      })

      if (responseType === 'blob') {
        // 新規登録の場合、アカウント一覧をダウンロード
        const blob = new Blob([res.data], { type: res.data.type })
        if (res.data.type  === 'application/json') {
          // 登録エラー
          return {status: 'error', message: JSON.parse(await res.data.text()).messages}
        } else {
          //レスポンスヘッダからファイル名を取得
          const contentDisposition = res.headers['content-disposition']
          let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                        contentDisposition.length
                                                    )
          //デコードするとスペースが"+"になるのでスペースへ置換
          fileName = decodeURI(fileName).replace(/\+/g, ' ')
          saveAs(blob, fileName)
        }
      }
      return {status: 'success', message: `${title}が完了しました` }
    },
  },
}
